import { Box, Typography, useTheme } from '@mui/material';
import Header from '@/Components/MagicLink/Header';
import WarningIcon from '@/Components/MagicLink/WarningIcon';
import Section from '@/Components/MagicLink/Section';
import {
    magicLinkCenteredHeroInnerSx,
    magicLinkPageColumnSx,
    magicLinkPageOuterSx,
} from '@/Utils/MagicLink/pageLayout';

const ExpiredLinkView = () => {
    const theme = useTheme();

    return (
        <Box component="main" sx={magicLinkPageOuterSx}>
            <Box sx={magicLinkPageColumnSx}>
                    {/* Centered status block — logo sits directly above the message
                        section, sharing the card's left edge. */}
                    <Box sx={magicLinkCenteredHeroInnerSx}>
                        <Box
                            sx={{
                                width: '100%',
                                maxWidth: 480,
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 2,
                            }}
                        >
                            <Header />

                            <Section>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        textAlign: 'center',
                                        gap: 2,
                                        paddingY: 1,
                                    }}
                                >
                                    <WarningIcon height={60} width={64} />
                                    <Typography variant="h5" component="h1" color={theme.palette.error.dark}>
                                        Neplatný link
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        Odkaz, ktorý sa snažíte otvoriť, je neplatný alebo jeho platnosť už vypršala. Požiadajte o nový odkaz.
                                    </Typography>
                                </Box>
                            </Section>
                        </Box>
                    </Box>
            </Box>
        </Box>
    );
};

export default ExpiredLinkView;
